import React, { useState } from 'react';
import { Icon, ListItemText, Badge, Box } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import VerticalNavItem from '@tenant/core/AppLayout/components/VerticalNav/VerticalItem/VerticalNavItem';
import WhatsNewModal from './WhatsNewModal';
import { whatsNewItems, getLatestItems } from './whatsNewConfig';
import IntlMessages from '@tenant/utility/IntlMessages';

const WhatsNewNavItem = ({ level = 0 }) => {
  const [modalOpen, setModalOpen] = useState(false);
  
  // Get items from the last 30 days for the badge count
  const recentItems = getLatestItems().filter(item => {
    const itemDate = new Date(item.date);
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    return itemDate >= thirtyDaysAgo;
  });

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <VerticalNavItem
        level={level}
        button
        onClick={handleOpenModal}
      >
        <Box component='span'>
          <Icon
            sx={{
              fontSize: 18,
              display: 'block',
              mr: 4,
            }}
            className={clsx('nav-item-icon', 'material-icons-outlined')}
            color='action'
          >
            new_releases
          </Icon>
        </Box>
        <ListItemText
          className='nav-item-content'
          primary={
            <IntlMessages id="WhatsNewSection" defaultMessage="What's New" />
          }
          classes={{ primary: 'nav-item-text' }}
        />
        {recentItems.length > 0 && (
          <Box sx={{ mr: 3.5 }} className='menu-badge'>
            <Badge 
              badgeContent={recentItems.length} 
              color="error"
              sx={{
                '& .MuiBadge-badge': {
                  fontSize: '0.75rem',
                  minWidth: 18,
                  height: 18,
                  borderRadius: '9px',
                }
              }}
            >
              <Box />
            </Badge>
          </Box>
        )}
      </VerticalNavItem>

      <WhatsNewModal 
        open={modalOpen}
        onClose={handleCloseModal}
        items={whatsNewItems}
      />
    </>
  );
};

WhatsNewNavItem.propTypes = {
  level: PropTypes.number,
};

export default WhatsNewNavItem;
